export const gradients = {
    cool: require("./Color_Voice_1.png"),
    warm: require("./Color_Voice_2.png"),
    hot: require("./Color_Voice_3.png"),
    fire: require("./Color_Voice_4.png"),
};
